import { useFormContext } from 'react-hook-form';

import { Button, DialogActionsContainer } from '@sbv-clients/ui-shared';
import { ActionLabels } from '@sbv-clients/util-misc';

export function SubmitActions({ onCancel }: { onCancel: () => void }) {
  const {
    formState: { isValid, isSubmitting },
  } = useFormContext();

  return (
    <DialogActionsContainer>
      <Button variant="outlined" onClick={onCancel}>
        {ActionLabels.Cancel}
      </Button>
      <Button
        type="submit"
        variant="contained"
        disabled={!isValid || isSubmitting}
      >
        {ActionLabels.Confirm}
      </Button>
    </DialogActionsContainer>
  );
}
